export const mockInfluencers = [
  {
    id: "1",
    name: "Jessica Martinez",
    handle: "@jessicam",
    platform: "tiktok",
    followers: "2.3M",
    avatar: "https://public.readdy.ai/ai/img_res/1d9c807eabf688f2116f9ed419d78354.jpg",
    category: "Tech & Lifestyle",
    earnings: "$12,430",
    sales: 1842,
    commission: "12%",
    verified: true,
  },
  {
    id: "2",
    name: "Sarah Chen",
    handle: "@sarahchen_beauty",
    platform: "youtube",
    followers: "890K",
    avatar: "https://readdy.ai/api/search-image?query=asian%20woman%20beauty%20influencer%20portrait%20glowing%20skin%20professional&width=80&height=80&seq=inf2&orientation=squarish",
    category: "Beauty & Skincare",
    earnings: "$8,920",
    sales: 1203,
    commission: "10%",
    verified: true,
  },
  {
    id: "3",
    name: "Tyler Brooks",
    handle: "@tylerbrooks_fit",
    platform: "twitter",
    followers: "445K",
    avatar: "https://readdy.ai/api/search-image?query=athletic%20man%20fitness%20trainer%20portrait%20confident%20smile&width=80&height=80&seq=inf3&orientation=squarish",
    category: "Fitness & Sports",
    earnings: "$5,670",
    sales: 892,
    commission: "8%",
    verified: true,
  },
  {
    id: "4",
    name: "Priya Sharma",
    handle: "@priyacooks",
    platform: "youtube",
    followers: "1.1M",
    avatar: "https://readdy.ai/api/search-image?query=indian%20woman%20food%20blogger%20portrait%20kitchen%20background%20warm%20smile&width=80&height=80&seq=inf4&orientation=squarish",
    category: "Food & Home",
    earnings: "$9,340",
    sales: 1567,
    commission: "11%",
    verified: true,
  },
  {
    id: "5",
    name: "DeShawn Williams",
    handle: "@deshawn_style",
    platform: "tiktok",
    followers: "3.8M",
    avatar: "https://readdy.ai/api/search-image?query=young%20black%20man%20fashion%20influencer%20portrait%20stylish%20outfit%20confident&width=80&height=80&seq=inf5&orientation=squarish",
    category: "Fashion & Style",
    earnings: "$21,890",
    sales: 3421,
    commission: "15%",
    verified: true,
  },
  {
    id: "6",
    name: "Emma Rodriguez",
    handle: "@emmalifestyle",
    platform: "instagram",
    followers: "678K",
    avatar: "https://readdy.ai/api/search-image?query=latina%20woman%20lifestyle%20influencer%20portrait%20bright%20smile%20natural%20light&width=80&height=80&seq=inf6&orientation=squarish",
    category: "Lifestyle & Home",
    earnings: "$4,210",
    sales: 634,
    commission: "8%",
    verified: true,
  },
  {
    id: "7",
    name: "Li Wei",
    handle: "@liwei_douyin",
    platform: "douyin",
    followers: "5.2M",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20man%20influencer%20portrait%20stylish%20modern%20background%20professional&width=80&height=80&seq=inf7&orientation=squarish",
    category: "Electronics & Gadgets",
    earnings: "$31,200",
    sales: 4890,
    commission: "13%",
    verified: true,
  },
  {
    id: "8",
    name: "Mei Lin",
    handle: "@meilin_weixin",
    platform: "weixin",
    followers: "1.8M",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20woman%20influencer%20portrait%20elegant%20professional%20headshot&width=80&height=80&seq=inf8&orientation=squarish",
    category: "Fashion & Beauty",
    earnings: "$18,750",
    sales: 2930,
    commission: "11%",
    verified: true,
  },
  {
    id: "9",
    name: "Marcus Johnson",
    handle: "@marcusj_fb",
    platform: "facebook",
    followers: "920K",
    avatar: "https://readdy.ai/api/search-image?query=middle%20aged%20black%20man%20portrait%20professional%20confident%20smile%20casual&width=80&height=80&seq=inf9&orientation=squarish",
    category: "Home & Garden",
    earnings: "$7,640",
    sales: 1120,
    commission: "9%",
    verified: true,
  },
];

export const mockCommissionTiers = [
  { tier: "Starter", followers: "1K - 10K", commission: "5%", perks: ["Basic product catalog", "Standard support", "Monthly PayPal payout"] },
  { tier: "Rising Star", followers: "10K - 100K", commission: "8%", perks: ["Full product catalog", "Priority support", "Bi-weekly PayPal payout", "Exclusive deals"] },
  { tier: "Influencer", followers: "100K - 1M", commission: "12%", perks: ["VIP product access", "Dedicated manager", "Weekly PayPal payout", "Co-branded campaigns"] },
  { tier: "Mega Star", followers: "1M+", commission: "15%", perks: ["Custom commission rates", "Factory direct access", "Daily PayPal payout", "Brand partnerships"] },
];

export const mockMyEarnings = [
  { id: "e1", productTitle: "Premium Wireless Earbuds Pro X200", factory: "TechVision Factory", factoryCommission: "12%", orderDate: "2026-04-10", buyer: "Marcus J.", amount: 49.99, commission: 6.00, status: "paid", platform: "tiktok" },
  { id: "e2", productTitle: "Vitamin C Brightening Serum 30ml", factory: "PureGlow Labs", factoryCommission: "10%", orderDate: "2026-04-09", buyer: "Aisha W.", amount: 59.97, commission: 5.99, status: "paid", platform: "tiktok" },
  { id: "e3", productTitle: "Organic Cotton Oversized Hoodie", factory: "GreenThread Mills", factoryCommission: "15%", orderDate: "2026-04-11", buyer: "Lily T.", amount: 69.98, commission: 10.50, status: "pending", platform: "tiktok" },
  { id: "e4", productTitle: "Portable Bluetooth Speaker IPX7", factory: "SoundWave Factory", factoryCommission: "12%", orderDate: "2026-04-08", buyer: "Carlos R.", amount: 39.99, commission: 4.80, status: "paid", platform: "tiktok" },
  { id: "e5", productTitle: "Resistance Bands Set 5-Level", factory: "FitForge Manufacturing", factoryCommission: "8%", orderDate: "2026-04-12", buyer: "James P.", amount: 67.96, commission: 5.44, status: "pending", platform: "tiktok" },
  { id: "e6", productTitle: "Smart LED Desk Lamp with USB-C", factory: "LightCraft Industries", factoryCommission: "10%", orderDate: "2026-04-07", buyer: "Nina P.", amount: 28.99, commission: 2.90, status: "paid", platform: "tiktok" },
];
